<script>
export default {
    name: 'IconVirementLight',
}
</script>
<template>
    <svg class="base-icon icon-virement-light" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  fill-rule="evenodd" d="M0 29.19h13.241v4.413H0V29.19ZM6.62 15.948h6.621v4.414h-6.62v-4.414ZM6.62 42.431h6.621v4.414h-6.62V42.43ZM40.828 55.672c-12.799 0-23.173-10.374-23.173-23.172S28.03 9.328 40.828 9.328C53.626 9.328 64 19.702 64 32.5S53.626 55.672 40.828 55.672Zm0-4.634a18.538 18.538 0 1 0 0-37.075 18.538 18.538 0 0 0 0 37.075Zm-4.519-20.855h11.47v4.634H36.31a5.792 5.792 0 0 0 9.417 3.268l3.94 2.625a10.427 10.427 0 0 1-18.042-5.893H29.24v-4.634h2.38a10.427 10.427 0 0 1 18.047-5.893l-3.942 2.625a5.792 5.792 0 0 0-9.417 3.268Z" clip-rule="evenodd"/></svg>
</template>
